module.exports = __webpack_public_path__ + "static/media/mo.de26729c.svg";